import pharmacyPrescriptions from './pharmacyPrescriptionsReducer';
import analytics from './analyticsReducer';

export {
  pharmacyPrescriptions,
  analytics,
};
